import Axios from "axios";
import { SETTINGS } from "../properties/ApiProps";

export const RequestBirthCertificateRepository = {
  create: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}requestBirthCertificate`,
      method: "POST",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },

  update: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}requestBirthCertificate`,
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },

  get: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}requestBirthCertificate/${id}`,
      method: "GET",
    });
  },
};
